<template>
  <div>
    <div class="tips">
      暂无权限，请联系系统管理员分配权限，或
      <a :href="`${config.API_BASE}/map`">选择其他项目</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.tips {
  font-size: 20px;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
